/*
 * @Author: ilal 1
 * @Date: 2023-05-10 14:34:18
 * @LastEditors: ilal 1
 * @LastEditTime: 2023-05-13 17:51:35
 * @FilePath: \web 2.0\src\api\api.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BaseAxios } from "@/Core/net/axios";
import qs from "qs";
import {
  config,
  getApiSign,
  onDynamicHeader,
  onHandleResponseData,
} from "./axiosConfig";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { useGlobalState } from "@/store/commonStore";
import { langArray } from "@/Core/default";
import i18n from "@/Core/i18n";
import { updateDocumentLang } from "@/Core/utils";

const axios = new BaseAxios({
  requestConfig: config,
  onDynamicHeader: onDynamicHeader,
  onHandleResponseData: onHandleResponseData,
  handleSign: getApiSign,
});

const handlerLang = (settingInfo) => {
  const langInfo = settingInfo?.languageConfig?.language.split(",");
  const newlangArr = langArray.filter((item) => langInfo?.includes(item.id));
  const defaultLang = newlangArr.filter(
    (item) => item.id === String(settingInfo?.languageConfig?.default_language)
  )[0];
  const newLangarrMap = newlangArr.map((i) => i.lang);
  window.newLangarrMap = newLangarrMap;

  // 获取当前语言
  const currentLang = i18n.language || localStorage.getItem("i18nextLng");
  // console.log(
  //   "[handlerLang] Current language:",
  //   currentLang,
  //   "Supported languages:",
  //   newLangarrMap
  // );

  /* 有默认语言 */
  if (defaultLang) {
    /* 第一次进网站的语言 */
    if (localStorage.getItem("i18nextLng") === "fallbackLng") {
      const targetLang = defaultLang ? defaultLang?.lang : newLangarrMap[0];
      // console.log(
      //   "[handlerLang] First visit, setting default language:",
      //   targetLang
      // );
      i18n.init({
        fallbackLng: targetLang,
      });
      localStorage.setItem("i18nextLng", targetLang);
      i18n.changeLanguage(targetLang);
      updateDocumentLang(targetLang);
      window.defaultLang = defaultLang.lang;
    } else {
      const storedLang = localStorage.getItem("i18nextLng");
      const filterLang = newlangArr.findIndex((v) => v.lang === storedLang);
      /* 判断当前是否支持该语言 */
      if (filterLang !== -1) {
        // 检查是否需要切换语言
        if (currentLang !== storedLang) {
          // console.log(
          //   "[handlerLang] Language change needed:",
          //   currentLang,
          //   "->",
          //   storedLang
          // );
          i18n.init({
            fallbackLng: storedLang,
          });
          localStorage.setItem("i18nextLng", storedLang);
          i18n.changeLanguage(storedLang);
          updateDocumentLang(storedLang);
        } else {
          // console.log(
          //   "[handlerLang] Language is already correct, no change needed:",
          //   currentLang
          // );
          // 确保 HTML lang 属性与当前语言匹配
          updateDocumentLang(storedLang);
        }
        window.defaultLang = storedLang;
      } else {
        const targetLang = defaultLang ? defaultLang?.lang : newLangarrMap[0];
        // 检查是否需要切换语言
        if (currentLang !== targetLang) {
          // console.log(
          //   "[handlerLang] Language change needed (unsupported lang):",
          //   currentLang,
          //   "->",
          //   targetLang
          // );
          i18n.init({
            fallbackLng: targetLang,
          });
          localStorage.setItem("i18nextLng", targetLang);
          i18n.changeLanguage(targetLang);
          updateDocumentLang(targetLang);
        } else {
          // console.log(
          //   "[handlerLang] Language is already correct, no change needed:",
          //   currentLang
          // );
          // 确保 HTML lang 属性与当前语言匹配
          updateDocumentLang(targetLang);
        }
        window.defaultLang = defaultLang.lang;
      }
    }
  } else {
    const targetLang = newLangarrMap[0];
    // 检查是否需要切换语言
    if (currentLang !== targetLang) {
      // console.log(
      //   "[handlerLang] Language change needed (no default):",
      //   currentLang,
      //   "->",
      //   targetLang
      // );
      i18n.init({
        fallbackLng: targetLang,
      });
      localStorage.setItem("i18nextLng", targetLang);
      i18n.changeLanguage(targetLang);
      updateDocumentLang(targetLang);
    } else {
      // console.log(
      //   "[handlerLang] Language is already correct, no change needed:",
      //   currentLang
      // );
      // 确保 HTML lang 属性与当前语言匹配
      updateDocumentLang(targetLang);
    }
    window.defaultLang = targetLang;
  }
};

export const fetcher = <T>(API: any, { arg }: any): Promise<T> => {
  const { formData = false } = API;
  let params = arg;
  if (formData) {
    params = new URLSearchParams(qs.stringify(arg));
  }
  return axios.request<T | any>(API, params).then((res) => {
    if (API.path.includes("api/index/setting") && res) {
      window.cdnUrl = res?.cdnUrl;
      window.currencyPrecision = res?.currencyPrecision;
      // console.log(res);

      // handlerLang(res);
    }
    return res;
  });
};

export interface SWROptions {
  //缓存有效期
  dedupingInterval?: number;
  onSuccess?: (data, key, config) => void;
  /**当节点挂载的时候是否自动请求 */
  revalidateOnMount?: boolean;
}

export interface APIConfig {
  path: string;
  type?: string;
  needLogin?: boolean;
  formData?: boolean;
  baseURL?: string;
}

const stableStringify = (value: any): string => {
  if (value === null || value === undefined) return "";
  if (typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) {
    return `[${value.map((v) => stableStringify(v)).join(",")}]`;
  }
  const keys = Object.keys(value).sort();
  const entries = keys.map((k) => `${JSON.stringify(k)}:${stableStringify(value[k])}`);
  return `{${entries.join(",")}}`;
};

const buildAPIKey = <P>(API: APIConfig, args?: P) => {
  const parts = [
    API.path,
    API.type || "get",
    API.needLogin ? "1" : "0",
    API.baseURL || "",
    API.formData ? "1" : "0",
    args ? stableStringify(args) : "",
  ];
  return parts.join("|");
};

export const useAPI = <T, P>(
  API: APIConfig,
  args?: P,
  options?: SWROptions
) => {
  const params = { arg: args };
  const { needLogin } = API;
  const { isLogin } = useGlobalState();
  const { revalidateOnMount = true } = options || {};

  const swrKey = (needLogin ? isLogin : true) ? buildAPIKey(API, args) : null;
  const { data, isLoading, isValidating, error, mutate } = useSWR<T>(
    swrKey,
    () => fetcher<T>(API, { ...params }),
    { ...options, revalidateOnMount }
  );

  const revalidate = (data?: any, options?: { revalidate?: boolean }) => {
    return mutate(data, options);
  };
  return { data, isLoading, isValidating, error, mutate, revalidate };
};

export const useAPIMutation = <T, P>(API: APIConfig, options?) => {
  return useSWRMutation(
    API,
    (API, arg: { arg: P }) => {
      return fetcher<T>(API, { ...arg });
    },
    options
  );
};
